// Requires nav element

const nav = document.querySelector('.js-header');


if (nav.hasAttribute('data-notification')) {
    const notification = document.querySelector('.js-notification');
    const clearNotification  = document.querySelector('.js-header-clear-notification');
    const notificationHeight = notification.offsetHeight;
    const header = document.querySelector('.js-header');
    const headerHeight = header.offsetHeight;
    const clearHeight = headerHeight + notificationHeight;
    const notificationClose = document.querySelector('.js-notification-close');

    function getNotificationCookie (name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Get hideBanner cookie
    const hideNotification = getNotificationCookie('hideNotificationbanner');

    // If it's not set, show cookie banner and set hideBanner cookie for 30 days
    if(!hideNotification) {
        notification.classList.add('show');
        document.cookie = `hideNotificationbanner='true'; path=/; max-age=${60 * 60 * 24 * 30};`;
        nav.style.top = notificationHeight + 'px';
        if (typeof clearNotification != "undefined" && clearNotification != null) {
            clearNotification.style.height = clearHeight + 'px';
        }
       
        notificationClose.addEventListener("click", (e) => {
            notification.classList.remove('show');
            nav.style.top = '0px';
            if (typeof clearNotification != "undefined" && clearNotification != null) {
                clearNotification.style.height = headerHeight + 'px';
            }
            
        });
    }


}


if (typeof nav != "undefined" && nav != null) {

    let scrollPosition = 0;
    let ticking = false;

    document.addEventListener('scroll', function() {
        if (!ticking) {
            // Request animation frame method for perf, 
            // as per: https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event#scroll_event_throttling
            window.requestAnimationFrame(function() {
                // Check current scroll position against previous iteration
                if ((document.body.getBoundingClientRect()).top > scrollPosition) {
                    document.body.setAttribute('data-scroll-direction', 'up');
                } else {
                    document.body.setAttribute('data-scroll-direction', 'down');
                }
        
                // saves the new position for iteration.
                scrollPosition = document.body.getBoundingClientRect().top;

                // set ticking var to false
                ticking = false;
            });

            ticking = true;
        }
    });
}

// Requires a navTrigger element, as well as nav
const navTrigger = document.querySelector('.js-hidden-nav-trigger');

if (nav && navTrigger) {
    if (
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
        let observer = new IntersectionObserver((entries) => {
            if (entries[0].boundingClientRect.y < 0) { console.log('y');
                document.body.classList.add('animate-header');
                document.body.classList.remove('static-header');
            } else { console.log('n');
                document.body.classList.add('static-header');
                document.body.classList.remove('animate-header');
            }
        });
        observer.observe(navTrigger);
    } else {
        document.body.classList.add('show-header');
    }
}
